/** LocalStorage keys — referenced everywhere via these constants. */
export const STORAGE_KEYS = {
  TOKEN: 'token',
  REFRESH_TOKEN: 'refreshToken',
  USER: 'authUser',
  ROLE: 'roleName',
  PERMISSIONS: 'resourcePermissions',
  // Master panel sidebar "show all" / "show selected module only" choice
  // (components/layout/Sidebar.jsx). Cleared on every logout path (see
  // util/tokenManager.js clear()) so a fresh login always starts back in the
  // narrowed "selected" default, regardless of what was chosen before.
  MASTER_SIDEBAR_VIEW: 'anablr:masterSidebarView',
  // One-shot message for the login screen after httpClient force-logs-out a
  // still-open session (e.g. Master ends its organization's subscription
  // mid-session — see httpClient.js's tenant-block 401 handling). Always raw
  // sessionStorage, not routed through `storage` — it must survive exactly
  // the one hard navigation to /login that wrote it and never outlive the tab.
  PENDING_AUTH_NOTICE: 'anablr:pendingAuthNotice',
};

export default STORAGE_KEYS;
